"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _context6 = _interopRequireDefault(require("../Theme/context"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _ModalBase = _interopRequireDefault(require("./ModalBase"));
var _excluded = ["classNames", "children", "ComponentProps", "effect", "beforeOpen", "onOpen", "beforeClose", "onClose", "PaperComponent", "PaperComponentProps", "backdropComponentClickIsClose", "ContentComponent", "ContentComponentProps", "BackdropComponentProps"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var themeContext = (0, _react.useContext)(_context6["default"]);
  var _themeContext$additio = themeContext.additionalStyles,
    additionalStyles = _themeContext$additio === void 0 ? {} : _themeContext$additio;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.modal || defaultStyle : _props$classNames,
    children = props.children,
    _props$ComponentProps = props.ComponentProps,
    ComponentProps = _props$ComponentProps === void 0 ? {} : _props$ComponentProps,
    effect = props.effect,
    beforeOpen = props.beforeOpen,
    onOpen = props.onOpen,
    beforeClose = props.beforeClose,
    onClose = props.onClose,
    _props$PaperComponent = props.PaperComponent,
    PaperComponent = _props$PaperComponent === void 0 ? _Paper["default"] : _props$PaperComponent,
    _props$PaperComponent2 = props.PaperComponentProps,
    PaperComponentProps = _props$PaperComponent2 === void 0 ? {} : _props$PaperComponent2,
    _props$backdropCompon = props.backdropComponentClickIsClose,
    backdropComponentClickIsClose = _props$backdropCompon === void 0 ? true : _props$backdropCompon,
    _props$ContentCompone = props.ContentComponent,
    ContentComponent = _props$ContentCompone === void 0 ? _Paper["default"] : _props$ContentCompone,
    _props$ContentCompone2 = props.ContentComponentProps,
    ContentComponentProps = _props$ContentCompone2 === void 0 ? {} : _props$ContentCompone2,
    _props$BackdropCompon = props.BackdropComponentProps,
    BackdropComponentProps = _props$BackdropCompon === void 0 ? {} : _props$BackdropCompon,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var modal = (0, _react.useRef)();
  function setOpen(_x) {
    return _setOpen.apply(this, arguments);
  }
  function _setOpen() {
    _setOpen = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(value) {
      var br;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!modal.actions.setOpen) {
              _context5.next = 26;
              break;
            }
            br = false;
            if (!value) {
              _context5.next = 9;
              break;
            }
            if (!beforeOpen) {
              _context5.next = 7;
              break;
            }
            _context5.next = 6;
            return beforeOpen();
          case 6:
            br = _context5.sent;
          case 7:
            _context5.next = 13;
            break;
          case 9:
            if (!beforeClose) {
              _context5.next = 13;
              break;
            }
            _context5.next = 12;
            return beforeClose();
          case 12:
            br = _context5.sent;
          case 13:
            if (!br) {
              _context5.next = 15;
              break;
            }
            return _context5.abrupt("return");
          case 15:
            _context5.next = 17;
            return modal.actions.setOpen(value);
          case 17:
            if (!value) {
              _context5.next = 23;
              break;
            }
            if (!onOpen) {
              _context5.next = 21;
              break;
            }
            _context5.next = 21;
            return onOpen();
          case 21:
            _context5.next = 26;
            break;
          case 23:
            if (!onClose) {
              _context5.next = 26;
              break;
            }
            _context5.next = 26;
            return onClose();
          case 26:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _setOpen.apply(this, arguments);
  }
  var toggleOpen = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      var openBeforeToggle, br, openAfterToggle;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!modal.actions.toggleOpen) {
              _context.next = 29;
              break;
            }
            if (!modal.actions.getOpen) {
              _context.next = 17;
              break;
            }
            openBeforeToggle = modal.actions.getOpen();
            br = false;
            if (openBeforeToggle) {
              _context.next = 11;
              break;
            }
            if (!beforeOpen) {
              _context.next = 9;
              break;
            }
            _context.next = 8;
            return beforeOpen();
          case 8:
            br = _context.sent;
          case 9:
            _context.next = 15;
            break;
          case 11:
            if (!beforeClose) {
              _context.next = 15;
              break;
            }
            _context.next = 14;
            return beforeClose();
          case 14:
            br = _context.sent;
          case 15:
            if (!br) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return");
          case 17:
            _context.next = 19;
            return modal.actions.toggleOpen();
          case 19:
            openAfterToggle = _context.sent;
            if (!openAfterToggle) {
              _context.next = 26;
              break;
            }
            if (!onOpen) {
              _context.next = 24;
              break;
            }
            _context.next = 24;
            return onOpen();
          case 24:
            _context.next = 29;
            break;
          case 26:
            if (!onClose) {
              _context.next = 29;
              break;
            }
            _context.next = 29;
            return onClose();
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function toggleOpen() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, modal.actions ? modal.actions : {}), {}, {
          setOpen: setOpen,
          toggleOpen: toggleOpen
        }),
        current: modal.current
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setOpen: function () {
              var _setOpen2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              function setOpen() {
                return _setOpen2.apply(this, arguments);
              }
              return setOpen;
            }(),
            toggleOpen: function () {
              var _toggleOpen = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              function toggleOpen() {
                return _toggleOpen.apply(this, arguments);
              }
              return toggleOpen;
            }(),
            getOpen: function getOpen() {}
          },
          content: {}
        });
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_ModalBase["default"], Object.assign({}, rest, {
    classNames: classNames,
    ComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, ComponentProps), {}, {
      defaultClassName: (0, _clsx["default"])(classNames.isModal, ComponentProps.defaultClassName),
      ref: function ref(e) {
        modal.current = e;
        if (ComponentProps.ref) {
          if (typeof ComponentProps.ref === 'function') {
            ComponentProps.ref(e);
          } else if (ComponentProps.ref && typeof ComponentProps.ref === 'object') {
            ComponentProps.ref.current = e;
          }
        }
      }
    }),
    effect: function effect(_ref2) {
      var actions = _ref2.actions;
      modal.actions = actions;
    },
    ContentComponent: ContentComponent,
    ContentComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
      elevation: 0,
      color: 'paper3'
    }, ContentComponentProps), {}, {
      style: (0, _objectSpread2["default"])({
        borderRadius: 0
      }, ContentComponentProps.style ? ContentComponentProps.style : {}),
      className: (0, _clsx["default"])(classNames.modalContentContainer, ContentComponentProps.className)
    }),
    BackdropComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, BackdropComponentProps), {}, {
      className: (0, _clsx["default"])(classNames.modalBackdropComponent, BackdropComponentProps.className),
      onClick: function () {
        var _onClick = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(e) {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!backdropComponentClickIsClose) {
                  _context4.next = 3;
                  break;
                }
                _context4.next = 3;
                return toggleOpen();
              case 3:
                if (BackdropComponentProps.onClick) {
                  BackdropComponentProps.onClick(e);
                }
              case 4:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function onClick(_x2) {
          return _onClick.apply(this, arguments);
        }
        return onClick;
      }()
    })
  }), /*#__PURE__*/_react["default"].createElement(PaperComponent, Object.assign({
    ref: ref,
    defaultClassName: (0, _clsx["default"])(classNames.modalPaper, PaperComponentProps.defaultClassName),
    "container-type": 'root-root root-page',
    ContentComponent: 'Modal',
    color: 'paper1'
  }, PaperComponentProps), children));
});